
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ApplicationDelay,
  ApplicationState,
} from '../models';
import {
    ApplicationDelayFromJSON,
    ApplicationDelayToJSON,
    ApplicationStateFromJSON,
    ApplicationStateToJSON,
} from '../models';

/**
 * 
 */
export class FreelancerApplicationStateApi extends runtime.BaseAPI {

    /**
     * Acknowledges the application state
          */
    async acknowledgeApplicationStateRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/application-state/acknowledge`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledges the application state
          */
    async acknowledgeApplicationState(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeApplicationStateRaw(initOverrides);
    }

    /**
     * Returns the application state
          */
    async readApplicationStateRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ApplicationState>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ApplicationState>({
            path: `/profile/api/application-state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ApplicationStateFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the application state
          */
    async readApplicationState(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ApplicationState> {
        const response = await this.readApplicationStateRaw(initOverrides);
        return response._data;
    }

    /**
     * Returns information about delays to process the vetting
          */
    async vettingDelaysRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ApplicationDelay>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ApplicationDelay>({
            path: `/profile/api/application-state/delays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ApplicationDelayFromJSON(response._data); }
        return response;
    }

    /**
     * Returns information about delays to process the vetting
          */
    async vettingDelays(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ApplicationDelay> {
        const response = await this.vettingDelaysRaw(initOverrides);
        return response._data;
    }

}
